import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const CardsFrameToDownload = (props: QRFRameToPrintProps): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 197.953125 166.75 C 206.324219 166.21875 214.464844 167.382812 222.375 170.242188 C 333.746094 200.179688 445.113281 230.117188 556.484375 260.054688 C 576.800781 266.144531 586.082031 279.949219 584.328125 301.46875 C 570.347656 353.933594 556.667969 406.492188 543.296875 459.140625 C 542.972656 515.355469 542.644531 571.570312 542.320312 627.785156 C 538.347656 644.488281 528.085938 654.300781 511.546875 657.226562 C 386.175781 657.890625 260.800781 657.890625 135.429688 657.226562 C 118.007812 654.066406 107.75 643.585938 104.65625 625.792969 C 104.003906 543.296875 104.003906 460.800781 104.65625 378.308594 C 106.460938 366.171875 112.484375 357.023438 122.726562 350.867188 C 124.828125 349.457031 127.109375 348.625 129.566406 348.371094 C 143.25 295.457031 157.089844 242.566406 171.085938 189.703125 C 176.367188 177.480469 185.324219 169.832031 197.953125 166.75 Z M 202.835938 188.703125 C 320.496094 220 438.050781 251.765625 555.507812 284.003906 C 560.21875 287.132812 562.824219 291.625 563.324219 297.476562 C 561.289062 303.375 559.660156 309.359375 558.4375 315.441406 C 434.695312 282.507812 310.949219 249.578125 187.207031 216.644531 C 188.230469 209.460938 190.023438 202.472656 192.578125 195.691406 C 195.21875 191.945312 198.636719 189.617188 202.835938 188.703125 Z M 181.34375 237.601562 C 304.726562 270.691406 428.144531 303.621094 551.601562 336.394531 C 548.972656 349.460938 545.878906 362.433594 542.320312 375.316406 C 540.636719 367.285156 536.894531 360.464844 531.085938 354.855469 C 525.738281 352.148438 520.203125 349.820312 514.476562 347.871094 C 485.527344 346.589844 456.546875 345.925781 427.53125 345.875 C 342.578125 322.769531 257.585938 299.816406 172.550781 277.019531 C 172.042969 276.460938 171.714844 275.792969 171.574219 275.023438 C 174.746094 262.488281 178 250.015625 181.34375 237.601562 Z M 165.714844 299.472656 C 224.386719 314.625 283.003906 330.089844 341.558594 345.875 C 279.039062 346.375 216.515625 346.542969 153.988281 346.375 C 157.441406 330.605469 161.351562 314.96875 165.714844 299.472656 Z M 136.40625 369.328125 C 261.453125 369.160156 386.5 369.328125 511.546875 369.828125 C 516.359375 371.75 519.453125 375.242188 520.824219 380.304688 C 521.152344 384.960938 521.476562 389.617188 521.804688 394.273438 C 522.457031 470.78125 522.457031 547.289062 521.804688 623.796875 C 519.785156 630.515625 515.390625 634.339844 508.613281 635.269531 C 385.847656 635.9375 263.082031 635.9375 140.3125 635.269531 C 131.683594 634.441406 126.960938 629.617188 126.148438 620.800781 C 125.496094 541.964844 125.496094 463.132812 126.148438 384.296875 C 126.730469 377.222656 130.148438 372.234375 136.40625 369.328125 Z M 136.40625 369.328125 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 207.847656 395.027344 C 220.675781 395.089844 231.441406 399.867188 240.136719 409.367188 C 256.417969 393.925781 274.355469 391.535156 293.949219 402.199219 C 309.433594 414.601562 314.894531 430.691406 310.324219 450.472656 C 299.261719 476.433594 280.386719 485.199219 253.707031 476.761719 C 248.371094 474.359375 243.691406 471.011719 239.667969 466.726562 C 217.417969 485.316406 196.050781 484.359375 175.558594 463.859375 C 164.691406 445.792969 165.003906 427.949219 176.496094 410.324219 C 185.042969 400.9375 195.496094 395.835938 207.847656 395.027344 Z M 204.105469 417.015625 C 194.742188 420.382812 189.75 427.234375 189.128906 437.566406 C 190.464844 450.246094 197.332031 457.414062 209.71875 459.078125 C 222.109375 457.414062 228.972656 450.246094 230.308594 437.566406 C 227.707031 422.652344 218.972656 415.800781 204.105469 417.015625 Z M 265.871094 417.015625 C 256.257812 420.179688 250.957031 427.03125 249.960938 437.566406 C 251.351562 450.460938 258.371094 457.628906 271.019531 459.078125 C 281.347656 457.761719 287.898438 452.027344 290.671875 441.871094 C 290.976562 424.816406 282.710938 416.527344 265.871094 417.015625 Z M 265.871094 417.015625 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 168.539062 552.765625 C 183.828125 552.765625 199.113281 552.765625 214.398438 552.765625 C 214.398438 559.773438 214.398438 566.785156 214.398438 573.796875 C 199.113281 573.796875 183.828125 573.796875 168.539062 573.796875 C 168.539062 566.785156 168.539062 559.773438 168.539062 552.765625 Z M 168.539062 552.765625 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 257.449219 552.765625 C 272.734375 552.765625 288.019531 552.765625 303.304688 552.765625 C 303.304688 559.773438 303.304688 566.785156 303.304688 573.796875 C 288.019531 573.796875 272.734375 573.796875 257.449219 573.796875 C 257.449219 566.785156 257.449219 559.773438 257.449219 552.765625 Z M 257.449219 552.765625 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 346.355469 552.765625 C 361.644531 552.765625 376.929688 552.765625 392.214844 552.765625 C 392.214844 559.773438 392.214844 566.785156 392.214844 573.796875 C 376.929688 573.796875 361.644531 573.796875 346.355469 573.796875 C 346.355469 566.785156 346.355469 559.773438 346.355469 552.765625 Z M 346.355469 552.765625 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 435.265625 552.765625 C 450.550781 552.765625 465.835938 552.765625 481.121094 552.765625 C 481.121094 559.773438 481.121094 566.785156 481.121094 573.796875 C 465.835938 573.796875 450.550781 573.796875 435.265625 573.796875 C 435.265625 566.785156 435.265625 559.773438 435.265625 552.765625 Z M 435.265625 552.765625 "
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 364.582031 447.804688 L 843.75 447.804688 C 855.257812 447.804688 864.582031 457.128906 864.582031 468.632812 L 864.582031 947.679688 C 864.582031 959.183594 855.257812 968.507812 843.75 968.507812 L 364.582031 968.507812 C 353.078125 968.507812 343.75 959.183594 343.75 947.679688 L 343.75 468.632812 C 343.75 457.128906 353.078125 447.804688 364.582031 447.804688 Z M 364.582031 447.804688 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="1050.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
